module.exports = __webpack_public_path__ + "static/media/Other-Origins.149c38bc.png";